module.exports = __webpack_public_path__ + "media/images/next-06963cd0667074c7cbaa408d6d40f4ba.svg";